import { html } from 'lit';
import { ArrowDown } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-arrow-down')
export class PdsIconArrowDown extends PdsIcon {
  @state()
  icon = ArrowDown;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
